import { React, DomeComponent, DomeManipulator, DomeRouter } from "@lexriver/dome";
import css from './TopBarIcon.m.scss'
import cssAnimation from '../Animation.m.scss'
import { EnumIconNames } from "../enums/EnumIconNames";
import { UrlGenerator } from "../UrlGenerator";
import { GlobalFavorites } from "../GlobalFavorites";

interface Attrs{

}

export class FavoritesTopIcon extends DomeComponent<Attrs>{
    //counter:number = 0
    refContainer!:HTMLDivElement

    render(){
        return (
            <div class={css.container} ref={ref => { this.refContainer = ref; }} onClick={() => this.onClick()}></div>
        )
    }
    async afterRender(){
        // GlobalState.basketSmallDiv = this.rootElement as HTMLDivElement

        GlobalFavorites.onFavoritesUpdateEvent.subscribe(async () => {
            // console.log('Favorites:UpdateEvent')
            if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        GlobalFavorites.onFavoritesEmptyOrNotEvent.subscribe(async () => {
            // console.log('Favorites:EmptyOrNotEvent')
            if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
            this.scheduleUpdate()

        })
        
        this.scheduleUpdate()

    }

    onClick(){
        // alert('TODO')
        DomeRouter.navigate(UrlGenerator.favorites)
    }

    async updateAsync(){
        //this.counter++
        // const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        // const cBasketStats = await basket.getStatsAsync()
        //console.log('))) cBasketStats=', cBasketStats)

        const favorites = await GlobalFavorites.getCurrentFavoritesAsync()
        
        
        await DomeManipulator.replaceAllChildrenAsync(
            this.refContainer, 
            this.renderIcon(favorites.getTotalQuantity()),
            undefined,
            {cssClassName:cssAnimation.basketHeader, timeMs: 300}
            )
        
    }

    renderIcon(quantity){
        return (
            <div class={css.iconContainer}>
                {/* <div>counter={this.counter}</div> */}
                <span class={EnumIconNames.HeartEmpty} style={{ fontSize: "20px", margin: '0 3px' }}  ></span>
                {quantity === 0 
                    //? <div>Добавьте товар</div>
                    ? <></>
                    : <>
                        <div class={css.counter}>{quantity}</div>
                        {/* {GlobalUser.checkIfCanSeeWholesalePrices()
                            ? <div class={css.sumContainer}>{Settings.formatNumberToPrice(basketStats.wholesaleSum)}</div>
                            : <div class={css.sumContainer}>{Settings.formatNumberToPrice(basketStats.retailSum)}</div>
                        } */}
                    </>
                }
            </div>
                
        )

    }
    
}

